export const API_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
export const API_STATUS_SUCCESS = "success";
export const API_STATUS_ERROR = "error";
